<template>
  <create-dialog
    width="60%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div :class="`col-6 col-sm-6 col-md-5 col-lg-5 col-xl-5`">
          <fg-input
            type="text"
            :label="`${$t('common_words.name')} *`"
            v-model="model.name"
            name="common_words.name"
            v-validate="modelValidations.name"
            :error="getError('common_words.name', true)"
            placeholder=" ..."
          >
          </fg-input>
        </div>
        <div :class="`col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2`">
          <fg-input
            type="text"
            :label="`${$t('common_words.symbol')} *`"
            v-model="model.abbreviation"
            name="common_words.symbol"
            v-validate="modelValidations.abbreviation"
            :error="getError('common_words.symbol', true)"
            placeholder="..."
          >
          </fg-input>
        </div>
        <div :class="`col-6 col-sm-6 col-md-5 col-lg-5 col-xl-5`">
          <div class="form-group has-label">
            <label for="">{{ $t('labor.unit_format') }}: *</label>
            <br />
            <el-select
              filterable
              class="select-primary mb-3 shadow-sm required-unit_formate"
              v-model="model.unit_formate"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                class="select-primary"
                v-for="item in dataFormate"
                :key="item.id + item.value"
                :label="item.value"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div :class="`col-12`">
          <select-businesses-component
            ref="selectBusiness"
            :showLoading="true"
            :requiered="true"
            :initialData="businessesInitial"
            @onChange="updateSelectedBusinesses"
            @showHideLoading="showHideLoading"
          />
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { isset } from 'src/util/Util';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [
    MixinDialog,
    MixinForm,
    MixinPermissions,
    MixinLoading,
    MixinValidations,
  ],
  data() {
    return {
      businessesInitial: [],
      disabledField: false,
      model: {
        name: null,
        abbreviation: null,
        unit_formate: null,
        businesses_id: [],
        businesses_names: [],
      },
      modelValidations: {
        name: { required: true },
        abbreviation: { required: true },
      },
      dataFormate: [
        { id: 'Entero', value: 'Entero' },
        { id: 'Decimal', value: 'Decimal' },
      ],
    };
  },
  methods: {
    validateForm() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.unit_formate)) {
            return this.validationInputsRequired('unit_formate');
          } else if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          } else {
            this.$emit('addEdit', this.model);
          }
        }
      });
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm') && this.isUpdate()) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const { id, name, abbreviation, unit_formate } = JSON.parse(
        sessionStorage.getItem('editForm')
      );
      this.model = {
        ...this.model,
        id,
        name,
        abbreviation,
        unit_formate,
        isEdit: true,
      };
      const { business, businesses } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);
      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
